app.component("insuranceMultiselect", {
	templateUrl: "app/src/js/components/insuranceMultiselect/insuranceMultiselect.html",
	bindings: {
		providers: "=",
		otherName: "=",
		collapsible: "<?",
	},
	controller: [
		"MEDICAL_INSURANCE",
		"Insurance",
		function (MEDICAL_INSURANCE, Insurance) {
			var $ctrl = this;
			$ctrl.options = MEDICAL_INSURANCE;
			$ctrl.filter = "";

			$ctrl.$onInit = function () {
				// A collapsible instance starts closed, showing just the summary line.
				$ctrl.open = !$ctrl.collapsible;
				// Rendering the control is not an answer, so an untouched patient is left with an
				// empty list - that is what keeps "No insurance set" distinct from a chosen
				// "No insurance / self-paid".
				if (!$ctrl.providers) {
					$ctrl.providers = [];
				}
			};

			$ctrl.isSelected = function (value) {
				return $ctrl.providers.indexOf(value) !== -1;
			};

			$ctrl.toggleOpen = function () {
				$ctrl.open = !$ctrl.open;
				if (!$ctrl.open) {
					$ctrl.filter = "";
				}
			};

			// What the collapsed header reads, for example "Southern Cross, NIB". An empty list is
			// the unanswered state and says so - it is not the same as a chosen "self-paid".
			$ctrl.summary = function () {
				if (!$ctrl.providers.length) {
					return "No insurance set";
				}
				return $ctrl.providers
					.map(function (value) {
						return Insurance.providerName(value, $ctrl.otherName);
					})
					.filter(function (name) { return !!name; })
					.join(", ");
			};

			// Counts ticked boxes. "No insurance" is one of them, so it counts like any other -
			// a ticked control reading "0 selected" would just look broken.
			$ctrl.selectedCount = function () {
				return $ctrl.providers.length;
			};

			// Every option is independent, including "No insurance / self-paid" - a patient can
			// hold cover and still choose to pay for a procedure themselves.
			//
			// The free-text insurer name only belongs to OTHER, so unticking OTHER discards it.
			$ctrl.toggle = function (value) {
				var index = $ctrl.providers.indexOf(value);
				if (index === -1) {
					$ctrl.providers.push(value);
				} else {
					$ctrl.providers.splice(index, 1);
					if (value === "OTHER") {
						$ctrl.otherName = "";
					}
				}
			};

			$ctrl.clear = function () {
				$ctrl.providers.splice(0, $ctrl.providers.length);
				$ctrl.otherName = "";
			};
		},
	],
});
